import { render, staticRenderFns } from "./AdminReportCategories.vue?vue&type=template&id=20f46fb6"
import script from "./AdminReportCategories.vue?vue&type=script&lang=js"
export * from "./AdminReportCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports